/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ActivityQueueNotifications {
    getFixupPrototypeFunction() { return ActivityQueueNotifications.fixupPrototype; }

    static newInstance(model: Partial<ActivityQueueNotifications>): ActivityQueueNotifications {
        let obj = Object.assign(new ActivityQueueNotifications(), model);
        ActivityQueueNotifications.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ActivityQueueNotifications>): ActivityQueueNotifications {
        if (!model) return null;
        return ActivityQueueNotifications.newInstance(<ActivityQueueNotifications> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ActivityQueueNotifications) {
        if (!obj) return;

        models.ActivityQueueNotifications.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ActivityQueueNotifications): boolean {
        Object.setPrototypeOf(obj, ActivityQueueNotifications.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.integrated_tool_account) {
            models.IntegratedToolAccount.fixupPrototype(this.integrated_tool_account);
        }
    }

    /**
     * Activity Queue Notifications enabled
     */
    enabled: boolean;

    integrated_tool_account: models.IntegratedToolAccount;

}
